import { ListBox, ListBoxItem } from "react-aria-components";

import Icon, { type IconName } from "./icon";
import styles from "./boxy-list.module.css";

export function BoxyList({
  label,
  children,
}: {
  children: React.ReactNode;
  label: string;
}) {
  return (
    <ListBox
      className={styles.boxyList}
      aria-label={label}
      selectionMode="single"
    >
      {children}
    </ListBox>
  );
}

/**
 * Retired in SR-301 phase 3: this used to be a hand-maintained three-name
 * subset ("square" | "box" | "link"). It is now just pallet's icon name,
 * so a list item can carry any icon pallet draws.
 */
export type SupportedIcon = IconName;

function itemIcon(icon?: SupportedIcon) {
  if (typeof icon !== "string") {
    return <></>;
  }

  return <Icon name={icon} size={24} />;
}

export function BoxyListItem({
  children,
  textValue,
  active,
  icon,
  disabled,
  onClick,
}: {
  onClick?: () => void;
  icon?: SupportedIcon;
  disabled?: boolean;
  active?: boolean;
  children: React.ReactNode;
  textValue: string;
}) {
  return (
    <ListBoxItem
      isDisabled={disabled === true}
      onClick={onClick}
      className={styles.boxyListItem}
      textValue={textValue}
      aria-label={textValue}
      data-active={active}
    >
      {itemIcon(icon)}
      <div className={styles.listItemContent}>{children}</div>
    </ListBoxItem>
  );
}
